








import {Component, Prop, Vue} from "vue-property-decorator";
import {bus} from "@/plugins/bus";
import {EventEmitter} from "@/interfaces/store-interfaces/event-emitter.interface";

@Component({
  components: {

  }
})

export default class AnchorNav extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  pathSections: any = null;

  @Prop() items: any[];
  @Prop() activeSection: number;

  mounted() {
    bus.$on(EventEmitter.Events.DATA_LOADED, () => {
      setTimeout(() => {
        this.pathSections = document.querySelectorAll('.scroll-section');
      });
    });
  }

  anchorNav(index) {
    this.scrollToTarget(this.pathSections[index]);
  }

  scrollToTarget(el) {
    let element = el;
    let headerOffset = 100;
    let elementPosition = window.pageYOffset + element.getBoundingClientRect().top;
    let offsetPosition = elementPosition - headerOffset;

    window.scrollTo(0 ,offsetPosition);
  }
}
